module.exports = __webpack_public_path__ + "static/ApsoftImg-e62255e8291b8ad9a9c50d96f65622b8.jpg";